import {Fragment} from "react";
import {Divider, Grid, Typography} from "@mui/material";

export const WordPressQuoteRatingBrokerage = ({
                                                  brokerageRate,
                                                  redirectToApp,
                                                  lng,
                                                  movingFrom,
                                                  movingTo,
                                                  shippingDetails,
                                                  NoRate,
                                                  RegisterLink,
                                                  Coupon,
                                                  Feedback
                                              }) => {

    return (
        <Fragment>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? '出口国家' : "Export Country"}
                </Typography>
                <Typography>
                    {movingFrom?.country}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? '进口国家' : "Import Country"}
                </Typography>
                <Typography>
                    {movingTo?.country}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? '进口省份' : "Import Province"}
                </Typography>
                <Typography>
                    {movingTo?.province || 'N/A'}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "商品描述" : "Product Description"}
                </Typography>
                <Typography>
                    {shippingDetails?.description || 'N/A'}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "HS编码" : "HS Code"}
                </Typography>
                <Typography>
                    {shippingDetails?.hscode}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "原产国" : "Origin Country"}
                </Typography>
                <Typography>
                    {shippingDetails?.originCountryCode}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "数量" : "Quantity"}
                </Typography>
                <Typography>
                    {shippingDetails?.quantity}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "货币" : "Currency"}
                </Typography>
                <Typography>
                    {shippingDetails?.currency}
                </Typography>
            </Grid>
            <Grid size={{xs: 4}}>
                <Typography sx={{fontWeight: '600'}}>
                    {lng === 'cn' ? "单价" : "Unit Price"}
                </Typography>
                <Typography>
                    $ {(+shippingDetails?.priceEach).toFixed(2)}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Divider/>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                {
                    +brokerageRate?.totalDutyandTax > 0 ?

                        <Typography sx={{textAlign: 'center', fontSize: '18px'}}>
                            <span style={{fontWeight: '600'}}>{lng === 'cn' ? "关税和税款" : "Duty And Tax"}:</span>
                            $ {(+brokerageRate?.totalDutyandTax)?.toFixed(2)} {brokerageRate?.currency}
                        </Typography>
                        :
                        <Typography sx={{textAlign: 'center', fontSize: '18px', fontWeight: '600'}}>
                            {lng === 'cn' ? "免除关税及税费" : "Exempt from Duties and Taxes"}
                        </Typography>
                }
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Typography sx={{textAlign: 'center', fontSize: '18px'}}>
                    <span style={{fontWeight: '600'}}>{lng === 'cn' ? "报关代理费" : "Customs Brokerage Fee"}:</span>
                    $ {(+brokerageRate?.totalBrokerageFees)?.toFixed(2)} {brokerageRate?.currency}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography>
                    {lng === 'cn' ? '预估费用仅供参考。' : "The estimated cost is for reference only."}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Feedback/>
            </Grid>
            <Grid size={{xs: 12}}>
                <RegisterLink/>
            </Grid>
            <Grid size={{xs: 12}}>
                <Coupon/>
            </Grid>
            {
                redirectToApp()
            }
        </Fragment>
    )
}